export enum PermisoMantisEnum {
    SOLO_LECTURA = 'solo_lectura',
    REPORTAR = 'reportar',
    ASIGNAR_USUARIO = 'asignar_usuario',
    EDITAR_RPTA_FINAL = 'editar_rpta_final',
    GESTIONAR_NOTAS = 'gestionar_notas',
    EDITAR = 'editar',
    MODIFICAR_RELACIONES = 'modificar_relaciones',
    ESTADO_ASIGNADO = 'estado_asignado',
    ESTADO_RESUELTO = 'estado_resuelto',
    ESTADO_CERRADO = 'estado_cerrado'
}
